import { Controller } from "@hotwired/stimulus";
import flatpickr from "flatpickr";


// Connects to data-controller="flatpickr"
export default class extends Controller {
  static values = { enableTime: Boolean };

  connect() {
    flatpickr(this.element, {
      minDate: Date.now(),
      enableTime: this.enableTimeValue,
      dateFormat: this.enableTimeValue ? "Y-m-d H:i" : "Y-m-d"
    });
  }
}
